import { formatInTimeZone } from "date-fns-tz";

const hasTimezoneDesignator = (value: string) =>
  /[zZ]$|[+-]\d{2}:?\d{2}$/.test(value);

// The reschedule preview sends the start as a naive UTC string
// ("2026-06-24 23:30:00"); normalize it so it is parsed as UTC, not local.
const parseUtcDateTime = (value: string) => {
  const isoLike = value.replace(" ", "T");
  return new Date(hasTimezoneDesignator(isoLike) ? isoLike : `${isoLike}Z`);
};

export const formatSessionDateTimeWithTimezone = (
  utcDateTime: string,
  timeZone: string,
  abbreviation?: string,
): string => {
  const date = parseUtcDateTime(utcDateTime);
  const dateTime = formatInTimeZone(date, timeZone, "MMM d, yyyy h:mm a");

  return abbreviation ? `${dateTime} (${abbreviation})` : dateTime;
};
